import { TableV2 } from 'components/Table/TableV2';
import { useSourcingExternalStore } from 'modules/sourcing-external/stores';
import { useDrawerV2 } from 'common/drawer/hooks/useDrawerV2';
import { useModalV2 } from 'common/modal/hooks/useModalV2';
import { SourcedCandidateQueryItem } from 'modules/sourcing-external/types/SourcedCandidateQueryItem';
import { SourcingExternalInviteCandidateDrawer } from 'modules/sourcing-external/components/SourcingExternalInviteCandidateDrawer';
import { getSourcingExternalSelectedCandidatesColumns } from 'modules/sourcing-external/tables/columns/getSourcingExternalSelectedCandidatesColumns';

export const SourcingExternalSelectedCandidatesTable = () => {
  const selectedRows = useSourcingExternalStore((state) => state.selectedRows);
  const onRemoveSelectedRow = useSourcingExternalStore(
    (state) => state.onRemoveSelectedRow
  );
  const { openDrawer } = useDrawerV2();
  const { openModal } = useModalV2();

  const handleViewDetails = (row: SourcedCandidateQueryItem, index: number) => {
    const nextRow = selectedRows[index + 1];
    const prevRow = selectedRows[index - 1];
    openDrawer({
      width: '500px',
      title: row.fullName ?? '',
      subtitle: row.location ?? '',
      children: (
        <SourcingExternalInviteCandidateDrawer
          row={row}
          currentIndex={index}
          total={selectedRows.length}
          onNext={
            nextRow ? () => handleViewDetails(nextRow, index + 1) : undefined
          }
          onPrev={
            prevRow ? () => handleViewDetails(prevRow, index - 1) : undefined
          }
        />
      )
    });
  };

  const handleRemove = (row: SourcedCandidateQueryItem) => {
    openModal({
      title: 'Remove candidate?',
      subtitle: 'This cannot be undone.',
      primaryButtonText: 'No',
      secondaryButtonText: 'Yes',
      secondaryButtonProps: {
        variant: 'tertiary',
        state: 'destructive'
      },
      onSecondaryAction: () => onRemoveSelectedRow(row)
    });
  };

  const columns = getSourcingExternalSelectedCandidatesColumns({
    handleViewDetails,
    handleRemove
  });

  return (
    <TableV2
      columns={columns}
      data={selectedRows}
      emptyStateComponent={<div>No candidates selected.</div>}
    />
  );
};
